export default {
    toastText: "Copiat!",
};
